document.addEventListener('DOMContentLoaded', () => {
  const roots = document.querySelectorAll('.c-image-layout');
  roots.forEach(root => {
    const swatches = Array.from(root.querySelectorAll('.c-image-layout__swatch'));
    const blocks = Array.from(root.querySelectorAll('.c-image-layout__block'));
    const selectedColorEl = root.querySelector('.c-image-layout__selected-color');
    const secondaryBtn = root.querySelector('.c-image-layout__secondary-button');
    const primaryBtn = root.querySelector('.c-image-layout__primary-button');
    const mobile_secondary_btn = root.querySelector('.c-flex-container__mobile-buttons .c-image-layout__secondary-button');
    const mobile_primary_btn = root.querySelector('.c-flex-container__mobile-buttons .c-image-layout__primary-button');

    swatches.forEach(swatch => {
      const index = parseInt(swatch.dataset.blockIndex, 10);
      swatch.addEventListener('click', () => {
        swatches.forEach(s => s.classList.remove('is-selected'));
        blocks.forEach(b => b.classList.remove('is-active'));

        swatch.classList.add('is-selected');
        if (blocks[index]) {
          blocks[index].classList.add('is-active');
        }

        // Update selected color text
        const colorName = swatch.dataset.colorName;
        if (selectedColorEl && colorName) {
          selectedColorEl.textContent = colorName;
        }

        // Update secondary button text
        const secondaryText = swatch.dataset.secondaryButtonText;
        if (secondaryBtn) {
          secondaryBtn.textContent = secondaryText;
          secondaryBtn.href = swatch.dataset.secondaryButtonUrl;
          secondaryBtn.classList.remove('c-button--default', 'c-button--inverted');
          secondaryBtn.classList.add(`c-button--${swatch.dataset.secondaryButtonVariant}`);
        }

        // Update primary button text and url and variant
        if (primaryBtn) {
          primaryBtn.textContent = swatch.dataset.primaryButtonText;
          primaryBtn.href = swatch.dataset.primaryButtonUrl;
          primaryBtn.classList.remove('c-button--default', 'c-button--inverted');
          primaryBtn.classList.add(`c-button--${swatch.dataset.primaryButtonVariant}`);
        }

        // Update mobile buttons text, href, and variant
        if (mobile_secondary_btn) {
          mobile_secondary_btn.textContent = swatch.dataset.secondaryButtonText;
          mobile_secondary_btn.href = swatch.dataset.secondaryButtonUrl;
          mobile_secondary_btn.classList.remove('c-button--default', 'c-button--inverted');
          mobile_secondary_btn.classList.add(`c-button--${swatch.dataset.secondaryButtonVariant}`);
        }
        if (mobile_primary_btn) {
          mobile_primary_btn.textContent = swatch.dataset.primaryButtonText;
          mobile_primary_btn.href = swatch.dataset.primaryButtonUrl;
          mobile_primary_btn.classList.remove('c-button--default', 'c-button--inverted');
          mobile_primary_btn.classList.add(`c-button--${swatch.dataset.primaryButtonVariant}`);
        }
      });
    });
  });
});